import { AssignPaymentAmounts } from './AssignPaymentAmounts';
export default AssignPaymentAmounts;